module.exports = __webpack_public_path__ + "img/n-box.c046650c.png";